<template>
    <div class="price-box relative">
        <div
        >
            <div
                class="rounded-b-none rounded-t-md lg:rounded-md p-4 py-2.5 md:py-3 lg:py-8 max-w-lg mx-auto text-center bg-gray-50 md:bg-white lg:bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center"
                :class="stylingNewVersion && !ctaDisabled ? 'pb-5 lg:p-8' : 'pb-5 sm:pb-3 md:pb-6 lg:p-8'"
            >


                <p v-if="typeof coupon !== 'undefined' && coupon.success">
                    <span v-if="coupon.discountType === 'PERCENTAGE'" class="text-white bg-red-500 px-4 font-bold text-xs sm:text-xxs md:text-sm rounded-md inline-block mb-0 lg:mb-1 uppercase py-1 lg:py-2" id="price-t-offer-banner">
                        {{
                            coupon.discountType === 'PERCENTAGE' ? `${coupon.discount}%` : `£${coupon.discount.toFixed(2)}`
                        }} Off... You're saving <span v-if="!loading">{{ (yearly ? (preDiscountPrice - price) : ((preDiscountPrice - price) * 12)) | toCurrency }}</span>
                    </span>

                    <span v-else-if="coupon.discountType === 'FREE_PRODUCT'" class="text-white bg-red-500 px-4 font-bold text-xs sm:text-xxs md:text-sm rounded-md inline-block mb-1 sm:mb-0 md:mb-1 uppercase py-1 lg:py-2" id="price-t-offer-banner">
                        FREE {{
                            coupon.value === 'FREEONWARD' ? `Onward Travel` : `Misfuel Assistance`
                        }} INCLUDED
                    </span>
                </p>


                <!--
                    Removed the style as it was avoiding the red banner to be shown.
                    <p v-else class="hidden md:block text-left lg:text-center text-lg leading-6 font-medium text-gray-900">
                -->
                <p v-else>
                    <span class="text-white bg-red-500 px-4 font-bold text-xxs md:text-sm rounded-md inline-block mb-0 md:mb-1 uppercase pt-0 md:pt-1"  id="price-t-offer-banner">
                        <span v-if="false && stylingNewVersion" class="text-xs sm:text-sm lg:text-xs xl:text-sm">Saving 70% Compared to The AA &amp; RAC</span>
                        <span v-else>Good news... You're saving 70%</span>
                        <sup class="text-base" style="font-size: 8px !important;">1</sup>
                    </span>
                </p>

                <div v-if="custom" class="font-bold relative text-xl text-gray-700 pt-4">
                    Contact our sales team
                </div>
                <div v-else class="mt-2 lg:mt-4 text-3xl lg:text-5xl font-extrabold text-gray-900">
                    <div v-if="priceBreakdown && isBusinessFlow()" class="flex justify-center">
                        <div class="pricing-breakdown w-11/12">
                            <div class="text-sm flex justify-between font-normal lg:text-base">
                            <span>
                                Net price:
                            </span>
                                <span class="inline-block text-right">
                                {{ price | toCurrency }}
                            </span>
                            </div>
                            <div class="text-sm flex justify-between font-normal lg:text-base">
                            <span>
                                VAT:
                            </span>
                                <span class="inline-block text-right">
                                {{ vatAmount | toCurrency }}
                            </span>
                            </div>
                            <div class="flex font-bold items-baseline justify-between text-xl mt-1 lg:mt-2">
                            <span>
                                Total:
                            </span>
                                <span class="inline-block text-right ml-4 text-2xl lg:text-3xl">
                                {{ (price + vatAmount) | toCurrency }}
                            </span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="flex justify-center lg:justify-between items-center lg:flex-col">
                        <div class="block items-end justify-center mr-2"
                            :class="{
                                'items-center lg:block': !isBusinessFlow()
                            }"
                        >
                            <span class="text-xs lg:text-sm mr-1 lg:mr-0 hidden lg:block" v-if="!isBusinessFlow()"></span>

                            <span class="flex items-center whitespace-nowrap text-left lg:text-center" :class="{
                                'text-2xl sm:text-3xl lg:text-5xl': price > 9999
                            }">

                                <!--<span v-if="preDiscountPrice > 0" class="text-xs sm:text-sm">Now</span>-->

                              <span  dusk="D-priceboxPrice">{{ price | toCurrency }}</span>
                                <span v-if="isBusinessFlow()" class="text-xs ml-1"> + VAT</span>
                                <span if="!loading" :class="[
                                    'ml-1 text-xs',
                                    isBusinessFlow()
                                      ? 'md:ml-1'
                                      : 'md:ml-2'
                                  ]">{{ (yearly ? 'per year' : 'per month') }}</span>
                            </span>

                            <span v-if="coupon.discountType !== null && coupon.discountType !== 'FREE_PRODUCT' && preDiscountPrice > 0 && price !== preDiscountPrice" class="block text-xs sm:text-sm text-gray-400 lg:pt-1">
                                    Was
                                    <span class="line-through">{{ preDiscountPrice | toCurrency }}</span>
                            </span>

                        </div>

                        <div v-if="partsAndLabourPrice && false" class="text-sm block mt-2 leading-normal text-gray-500">
                                 <span class="">Parts and Garage Cover ({{ partsAndLabourPrice | toCurrency }} of your quote)</span>
                        </div>

                        <div v-if="termToggle && cta !== 'Pay Now'" class="lg:mt-4 flex justify-center ml-2 md:ml-0">
                            <switch-button @input="changeTerm" v-model="yearly" :options="switchTermOptions"></switch-button>
                        </div>
                    </div>
                </div>

                <div v-if="typeof coupon !== 'undefined' && !coupon.hide && false">
                    <div class="mt-3 sm:mt-0 text-left" v-if="couponField" :class="{
                            'mt-0' : ctaHideMobile && !returningQuote,
                    }">
                        <div>
                            <div v-if="!coupon.success" class="sm:pt-4">
                                <label
                                        for="coupon"
                                        class="block text-sm font-medium text-gray-700"
                                >
                                    Coupon code
                                </label>
                                <div class="mt-1 flex items-center">
                                    <input
                                            id="coupon"
                                            v-model="coupon.value"
                                            type="text"
                                            name="coupon"
                                            class="uppercase shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full md:text-sm border-gray-300 rounded-md"
                                            placeholder="INSERT CODE HERE"
                                            :disabled="coupon.disabled"
                                            :class="{ 'bg-gray-100 text-gray-600': coupon.disabled }"
                                    />

                                    <button
                                        @click="applyCoupon"
                                        type="button"
                                        class="ml-2 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-5 font-medium rounded-md shadow-sm text-white bg-blue-600"
                                        :class="{
                                            'pointer-events-none opacity-25': !canApplyCoupon,
                                            'hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500': canApplyCoupon,
                                        }"
                                    >
                                        Apply
                                    </button>
                                </div>
                            </div>

                            <div v-if="coupon.message">
                                <!-- This example requires Tailwind CSS v2.0+ -->

                                <div v-if="coupon.success && returningQuote"
                                    class="bg-green-50 border-l-4 border-green-400 p-1 sm:p-2 mt-3 sm:mt-4"
                                >
                                    <div class="flex items-center">
                                        <div class="flex-shrink-0">
                                            <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg"
                                                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                      clip-rule="evenodd"/>
                                            </svg>
                                        </div>
                                        <div class="ml-2">
                                            <p class="text-xs text-green-700">
                                                {{ coupon.message }}
                                            </p>
                                        </div>
                                        <div @click="removeCoupon"
                                            class="cursor-pointer underline flex font-medium hover:underline items-center lg:ml-6 ml-4 text-green-900"
                                        >
                                            <span class="text-xs pr-1 sm:pr-0">Remove</span>
                                        </div>
                                    </div>
                                </div><!-- END -->
                                <div v-if="!coupon.success" class="bg-red-50 border-l-4 border-red-400 p-2 mt-4">
                                    <div class="flex items-center">
                                        <div class="flex-shrink-0">
                                            <svg class="h-5 w-5 text-red-400"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                aria-hidden="true"
                                            >
                                                <path fill-rule="evenodd"
                                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                                    clip-rule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                        <div class="ml-2">
                                            <p class="text-xs text-red-700">
                                                {{ coupon.message }}
                                                <!-- <a
                                                    href="javascript:void(0)"
                                                    @click="tryCouponAgain"
                                                    class="font-medium underline text-red-700 hover:text-red-600"
                                                >
                                                    Try again
                                                </a> -->
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3 sm:mt-6 text-sm" v-else-if="couponEnabled">
                        <a href="javascript:void(0)"
                            @click="showCouponField"
                            class="text-gray-700 hover:underline"
                        >
                            Have a discount code?
                        </a>
                    </div>
                </div>

                <div class="mt-3 md:mt-3 lg:mt-6 sm:hidden md:block" :class="{
                    'hidden md:block' : ctaHideMobile && !custom && !returningQuote,
                }">
                    <div class="rounded-md">
                        <a v-if="custom"
                            type="button"
                            :href="contactData.url"
                            class="w-full  px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-800 hover:bg-green-900"
                        >
                        <span v-if="contactData.type === 'email'"
                            class="flex items-center justify-center"
                        >
                            <svg class="-ml-0.5 mr-2 h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                            </svg>
                            Email us
                        </span>
                            <span v-else class="flex items-center justify-center">
                            <svg class="-ml-0.5 mr-2 h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                            </svg>
                            Call {{ phoneNumber }}
                        </span>
                        </a>
                        <button
                                v-else
                                data-testid="pricebox__cta"
                                type="button"
                                dusk="D-priceBoxContinue"
                                @click="submit"
                                name="pricebox__cta"
                                class="w-full flex items-center justify-center px-5 py-2.5 md:py-3 border text-base lg:text-lg font-bold font-poppins rounded-md"
                                :class="{
                                    'cursor-pointer bg-gray-200 text-gray-400 text-opacity-100 border-gray-300': ctaDisabled,
                                    'hidden' : ctaHidden,
                                    'hidden lg:block' : ctaHideMobile && !returningQuote,
                                    'bg-green-500 hover:bg-green-700 text-white border-transparent': !ctaDisabled
                                }"
                        >
                            {{ cta }}
                        </button>
                    </div>
                </div>

                <div v-if="false && stylingNewVersion && !ctaDisabled" class="mt-3 md:mt-0 lg:mt-6 md:hidden rounded-md">
                    <button
                                data-testid="pricebox__cta"
                                type="button"
                                @click="submit"
                                name="pricebox__cta"
                                class="w-full flex items-center justify-center px-5 py-3 border text-base lg:text-lg font-bold font-poppins rounded-md"
                                :class="{
                                    'hidden': ctaDisabled,
                                    'bg-green-500 hover:bg-green-700 text-white border-transparent': !ctaDisabled
                                }"
                        >
                           Continue
                    </button>
                </div>


                <div class="mt-3" v-if="custom">
                    9am to 5pm, Monday to Friday.
                </div>

                <div v-if="freeMot" class="mt-4">
                    <!-- This example requires Tailwind CSS v2.0+ -->
                    <div class="rounded-md bg-green-50 p-4">
                        <div class="flex justify-center lg:justify-start">
                            <div class="flex-shrink-0">
                                <!-- Heroicon name: check-circle -->
                                <svg class="h-5 w-5 text-green-400"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm font-medium text-green-800">
                                    You now qualify for a FREE MOT
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="cta !== 'Pay Now' || this.ctaHidden" class="hidden lg:flex flex-col">
                    <p class="font-sm text-left font-semibold pt-4">We accept:</p>
                    <payment-icons/>
                </div>

            </div>


            <div v-if="loading" dusk="D-priceboxLoadingSpinner"
                class="absolute flex h-full items-center justify-center left-0 top-0 w-full z-20"
            >
                <div class="absolute bg-gray-100 opacity-90 w-full h-full left-0 top-0"></div>
                <svg
                    class="relative z-30 animate-spin h-10 w-10 text-blue-800"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                    ></circle>
                    <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                </svg>
            </div>
        </div>

    </div>
</template>

<script>
import SwitchButton from "./SwitchButton.vue"

const FREE_MOT_MIN = 58 // GBP
import commonMethods from '../common/methods'
import PaymentIcons from './PaymentIcons.vue'
import Toggle from './Toggle.vue'
import { EventBus } from './../common/eventBus';

export default {
    name: 'PriceBox',
    components: {SwitchButton, PaymentIcons, Toggle},
    computed: {
        freeMot() {
            if (!this.showFreeMotOption) {
                return false
            }
            return this.price >= this.freeMotMin
        },
        freeProduct() {
            if (!this.showFreeProductOption) {
                return false
            }
            return this.price >= this.freeMot
        },
        canApplyCoupon() {
            if (!this.coupon) {
                return false
            }
            if (this.coupon.disabled) {
                return false
            }
            if (!this.coupon.value) {
                return false
            }
            if (!this.coupon.value.length) {
                return false
            }
            return true
        },
    },
    props: {
        price: {
            type: Number,
            default: null,
        },
        cta: {
            type: String,
            default: 'Checkout',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        custom: {
            type: Boolean,
            default: false,
        },
        contactData: {
            type: Object,
            default: () => {
            },
        },
        coupon: {
            type: Object,
            default: () => {
            },
        },
        couponEnabled: {
            type: Boolean,
            default: null,
        },
        showFreeMotOption: {
            type: Boolean,
            default: false,
        },
        showFreeProductOption: {
            type: Boolean,
            default: false,
        },
        enableCouponField: {
            type: Boolean,
            default: false,
        },
        priceBreakdown: {
            type: Boolean,
            default: false,
        },
        vatAmount: {
            type: Number,
            default: null,
        },
        ctaDisabled: {
            type: Boolean,
            default: false,
        },
        ctaHidden: {
            type: Boolean,
            default: false,
        },
        term: {
            type: String,
            default: 'year',
        },
        termToggle: {
            type: Boolean,
            default: true,
        },
        returningQuote: {
            type: Boolean,
            default: false,
        },
        preDiscountPrice: {
            type: Number,
            default: 0,
        },
        ctaHideMobile: {
            type: Boolean,
            default: false,
        },
        phoneNumber: {
            type: String,
            default: '0330 113 2433',
        },
        partsAndLabourPrice: {
            type: Number,
            default: 0,
        },
        stylingNewVersion: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            couponField: false,
            freeMotMin: FREE_MOT_MIN * 100,
            freeProductMin: FREE_MOT_MIN * 100,
            yearly: false,
            switchTermOptions: [
                {
                    label: 'Monthly',
                    value: false,
                },
                {
                    label: 'Yearly',
                    value: true,
                }
            ]
        }
    },
    methods: {
        ...commonMethods,
        applyFreeMotAddons() {
            this.$emit('applyfreemotaddons', true)
        },
        applyFreeAddons() {
            this.$emit('applyfreeaddons', true)
        },
        submit() {
            if(window.location.pathname === "/breakdown-cover/your-quote/review" || window.location.pathname === '/business-breakdown/your-quote/review') {
                EventBus.$emit('submitReview');
                return
            }
            if (this.ctaDisabled) {
                return
            }

            this.$emit('submit', true);
        },
        submitCustom() {
            this.$emit('submitCustom', true)
        },
        showCouponField() {
            this.couponField = true

            this.$nextTick(() => {
                if (!this.coupon) {
                    return
                }
                if (
                    !this.coupon.disabled &&
                    !this.coupon.success &&
                    document.getElementById('coupon')
                ) {
                    document.getElementById('coupon').focus()
                }
            })
        },
        applyCoupon() {
            if (this.coupon.disabled) {
                return
            }
            this.$emit('applycoupon', true)
        },
        removeCoupon() {
            this.$emit('removecoupon', true)
        },
        tryCouponAgain() {
            this.coupon.disabled = false
            this.coupon.value = null
            this.coupon.success = null
            this.coupon.message = null
            this.$nextTick(() => {
                document.getElementById('coupon').focus()
            })
        },
        changeTerm() {
            if (this.yearly) {
                this.$emit('changeterm', 'year')
                return
            }
            this.$emit('changeterm', 'month')
        },
        setYearly(yearly) {
            this.yearly = yearly
        },
        hasTermMismatch() {
            if (!window.currentRouteName) {
                return false;
            }

            if (window.currentRouteName !== 'join__quote--returning' && window.currentRouteName !== 'join__quote--returning--business') {
                return false;
            }
            if (!this.termToggle) {
                return false
            }
            if (this.term === 'year' && !this.yearly) {
                this.yearly = true
                return true
            }
            if (this.term === 'month' && this.yearly) {
                this.yearly = false
                return true
            }
            return false
        }
    },
    async mounted() {

        if (this.enableCouponField) {
            const isMobile = this.isMaxWidth('mobile')
            if (!isMobile) {
                this.couponField = true
            }

            if (this.returningQuote) {
                this.couponField = true
            }
        }
        this.loadTrustpilotWidget(this.$refs.trustboxMobile)
        if (this.hasTermMismatch()) {
            this.$emit('changeterm', this.term)
        }
    },
}
</script>

<style scoped>
.price-box {
    box-shadow: 0px -2px 13px 0px #9e9e9e;
}

@media screen and (min-width: 768px) {
    .price-box {
        box-shadow: none;
    }
}
</style>
